export default "__VITE_ASSET__DfMMNcZ2__"